import { createSlice } from "@reduxjs/toolkit";
import { getSourcingRequests } from "../../api/product/sourcing-request";

const initialState = {
  isLoading: false,
  sourcingRequests: [],
};

export const sourcingRequestSlice = createSlice({
  name: "sourcingRequest",
  initialState,
  reducers: {},
  extraReducers: {
    [getSourcingRequests.pending]: (state) => {
      state.isLoading = true;
    },
    [getSourcingRequests.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.sourcingRequests = payload;
    },
    [getSourcingRequests.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const sourcingRequestSelector = (state) => state.sourcingRequest;
export default sourcingRequestSlice.reducer;
